import { useMutation } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { useTranslation } from "react-i18next";
import { invalidateHomeCache } from "../../api/apiSettings";

export const useInvalidateHomeCache = () => {
    const { i18n } = useTranslation();
    const isArabic = (i18n.language || "en").startsWith("ar");

    return useMutation({
        mutationFn: () => invalidateHomeCache(),
        onSuccess: (response) => {
            toast.success(
                response?.message ||
                (isArabic ? "تم تفريغ كاش الصفحة الرئيسية" : "Home cache invalidated")
            );
        },
        onError: (error) => {
            const message =
                error?.response?.data?.message ||
                (isArabic ? "تعذر تفريغ كاش الصفحة الرئيسية" : "Failed to invalidate home cache");
            toast.error(message);
        },
    });
};
